import { loadable } from 'utils';

export default loadable(() => import('./index'), {});
